import * as z from "zod";
import { requiredString } from "components/form/utils";

export const EntitySchema = z.object({
    name: requiredString().nonempty("Entity cannot be empty"),
    organisation: requiredString(),
    status: requiredString(),
});
